exports = module.exports = require("../../../../../../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".AnswerType6 .block{position:relative;width:900px;height:500px;border:1px solid #d9d9d9;background-repeat:no-repeat;background-position:50%;background-size:contain}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/dist/cjs.js!./yii2/frontend/frontend-assets/src/components/Question/components/QuestionModal/components/components/Answers/components/AnswerType6/style.scss
// module id = 4904
// module chunks = 0